export const SET_LOGIN_PROCESSING = 'SET_LOGIN_PROCESSING';
export const SET_CREDENTIALS = 'SET_CREDENTIALS';
export const SET_ERROR_CREDENTIALS = 'SET_ERROR_CREDENTIALS';
export const SET_ISLOGGEDIN = 'SET_ISLOGGEDIN';
export const SET_LOGIN_EXTRA_MSG = 'SET_LOGIN_EXTRA_MSG';
export const SET_MUST_RENEW_PASS = 'SET_MUST_RENEW_PASS';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_CURRENT_SYSTEM = 'SET_CURRENT_SYSTEM';
export const SET_SHOW_CAPTCHA = 'SET_SHOW_CAPTCHA';